import { callServiceMachine } from '_core/util';
import Machines from '../Machines';
import { IFinalResponse } from '_core/types';
import { SampleRequestServiceType } from '../Types';

const machine = Machines.onSample.machine;

export const demostrationServiceMachine = (
  params: SampleRequestServiceType,
): Promise<IFinalResponse> => {
  return callServiceMachine(machine, params);
};

export default { demostrationServiceMachine };
